import type { UUID } from "@/core/types";

export const addendumKeys = {
  byNote: (noteId: UUID) => ["note", noteId, "addendums"] as const,
  cosignDetails: (addendumId: UUID) => ["addendum", addendumId, "cosign-details"] as const,
} as const;
